module.exports = __webpack_public_path__ + "img/calendar2-day-fill.c9693f04.svg";